import { createClient } from '@urql/core';

import { config } from './config';

// Set up the client for fetching data in the getProps page functions
export const urqlClient = createClient(config);
